import Link from 'next/link'
import {createLinkButton} from '@fitro/customer-ui/Button'

export const LinkButton = createLinkButton(Link)
